import { gql } from '@apollo/client';

// Defines where the Quiltt connector is launched from in the app, used to control post-linking routing behavior.
export type QuilttConnectorSource = 'onboarding' | 'profile';

export const GET_CONNECTION_QUERY = gql`
    query GetConnection($connectionId: ID!) {
        connection(id: $connectionId) {
            id
            status
            institution {
                id
                name
                logo {
                    url
                }
            }
            accounts {
                id
                name
                mask
            }
        }
    }
`;

export enum QuilttConnectionStatus {
    DISCONNECTED = 'DISCONNECTED',
    DISCONNECTING = 'DISCONNECTING',
    ERROR_INSTITUTION = 'ERROR_INSTITUTION',
    ERROR_PROVIDER = 'ERROR_PROVIDER',
    ERROR_REPAIRABLE = 'ERROR_REPAIRABLE',
    ERROR_SERVICE = 'ERROR_SERVICE',
    INITIALIZING = 'INITIALIZING',
    SYNCED = 'SYNCED',
    SYNCING = 'SYNCING',
    UPGRADING = 'UPGRADING',
}

export const BalancesNotReadyStatuses = [
    QuilttConnectionStatus.INITIALIZING,
    QuilttConnectionStatus.SYNCING,
    QuilttConnectionStatus.UPGRADING,
];

export interface QuilttConnectionResponse {
    connection: {
        id: string;
        status: QuilttConnectionStatus;
        institution: {
            id: string;
            name: string;
            logo?: {
                url: string;
            };
        };
        accounts: Array<{
            id: string;
            name: string;
            mask: string;
        }>;
    };
}
